import { HeaderLink as e, HeaderNavLink as t } from "../base/HeaderLink.js";
import { handlePrevLevelClick as n } from "../navState.js";
import { useNavLevels as r } from "../useNavLevels.js";
import { MENU_TRANSITION_TIME_CLASS as i } from "./MenuSlidingPanel.js";
import { MobileNavLevel1 as a } from "./MobileNavLevels.js";
import { useMediaQuery as o } from "./useMediaQuery.js";
import { usePortalClosing as s } from "./usePortalClosing.js";
import { useRef as c } from "react";
import { Arrow as l, Button as u, Chevron as d, Close as f } from "@sprd/sprd-component-kit/v2";
import p from "clsx";
import { jsx as m, jsxs as h } from "react/jsx-runtime";
import { Drawer as g } from "vaul";
//#region src/components/Header/mobile/MobileNav.tsx
function _({ items: _, active: v, open: y, onOpenChange: b, resetKey: x, linkComponent: S, title: C, closeLabel: w, banner: T, header: E, externalLinks: D = [], teaser: O, footerStart: k, footerLinks: A = [], socials: j }) {
	let M = c(null), [N, P] = r(_, v, x), F = o("(min-width: 834px)"), { willOpen: I, handleOpenChange: L } = s(y, b), R = c(!1);
	y && (R.current = !0);
	let z = N.filter((e) => e.isShown).at(-1), B = !!z;
	return /* @__PURE__ */ m(g.Root, {
		open: I,
		onOpenChange: L,
		direction: "right",
		handleOnly: !F,
		autoFocus: !0,
		children: /* @__PURE__ */ h(g.Portal, { children: [/* @__PURE__ */ m(g.Overlay, { className: "force-animation-150 fixed inset-0 z-50 bg-black/80" }), /* @__PURE__ */ m(g.Content, {
			ref: M,
			className: "force-animation-150 fixed top-0 right-0 z-50 h-dvh w-full min-w-auto overflow-hidden bg-white sm-md:w-1/3 sm-md:min-w-95",
			asChild: !0,
			children: /* @__PURE__ */ h("nav", { children: [
				/* @__PURE__ */ m(g.Title, {
					className: "sr-only",
					children: C
				}),
				T ? /* @__PURE__ */ m("div", {
					className: "relative sm-md:hidden",
					children: T
				}) : null,
				/* @__PURE__ */ h("div", {
					className: "flex h-full w-full flex-col sm-md:mt-0",
					children: [/* @__PURE__ */ h("div", {
						className: "flex h-(--mobile-nav-header-height) items-center justify-between border-b bg-white px-2 py-4",
						children: [z ? /* @__PURE__ */ h(u, {
							onClick: () => n(P, z),
							variant: "plain",
							className: "flex items-center gap-1 px-0! font-normal",
							children: [/* @__PURE__ */ m(d, { className: "size-6 rotate-90" }), /* @__PURE__ */ m("span", {
								className: "text-sm font-normal",
								children: z.label
							})]
						}) : null, /* @__PURE__ */ m(g.Close, {
							asChild: !0,
							children: /* @__PURE__ */ m(u, {
								variant: "plain",
								"aria-label": w,
								className: "ml-auto",
								children: /* @__PURE__ */ m(f, { className: "size-6" })
							})
						})]
					}), /* @__PURE__ */ m("div", {
						className: p("relative min-h-0 flex-1", z ? "-translate-x-(--mobile-menu-translate)" : "translate-none", i),
						children: /* @__PURE__ */ h("div", {
							tabIndex: B ? -1 : 0,
							className: "h-full overflow-y-auto",
							children: [
								E ? /* @__PURE__ */ m("div", {
									className: "flex flex-col gap-3 border-b p-4",
									children: E
								}) : null,
								/* @__PURE__ */ h("div", {
									className: "border-b",
									children: [/* @__PURE__ */ m("ul", {
										className: "flex flex-col gap-3 p-4",
										children: _.map((e) => /* @__PURE__ */ m(a, {
											navRef: M,
											item: e,
											levelStates: N,
											setLevelStates: P,
											activeLevel: z,
											closeLabel: w,
											linkComponent: S
										}, e.key))
									}), D.length > 0 && /* @__PURE__ */ m("ul", {
										className: "flex flex-col gap-3 border-t p-4",
										children: D.map((e) => e.link ? /* @__PURE__ */ m("li", {
											inert: B,
											children: /* @__PURE__ */ m(u, {
												variant: "plain",
												asChild: !0,
												className: "justify-between! px-0!",
												children: /* @__PURE__ */ h(t, {
													className: "flex w-full items-center justify-between gap-2 border-transparent!",
													link: e.link,
													linkComponent: S,
													children: [/* @__PURE__ */ h("div", {
														className: "flex flex-col items-start justify-start gap-0",
														children: [/* @__PURE__ */ m("span", {
															className: "font-made text-base font-normal",
															children: e.label
														}), /* @__PURE__ */ m("span", {
															className: "text-base font-normal text-neutral-700",
															children: e.subLabel
														})]
													}), /* @__PURE__ */ m(l, { className: "size-6 -rotate-45" })]
												})
											})
										}, e.key) : null)
									})]
								}),
								R.current && O ? /* @__PURE__ */ h("div", {
									className: "pt-4 pb-9 sm:py-9",
									inert: B,
									children: [O.headline ? /* @__PURE__ */ m("span", {
										className: "mb-3 px-4 font-made",
										children: O.headline
									}) : null, O.content]
								}) : null,
								/* @__PURE__ */ h("div", {
									className: "mt-auto",
									children: [/* @__PURE__ */ h("ul", {
										className: "flex flex-col gap-2 border-b p-4",
										children: [k ? /* @__PURE__ */ m("li", {
											inert: B,
											children: k
										}) : null, A.map((e) => e.link ? /* @__PURE__ */ m("li", {
											inert: B,
											children: /* @__PURE__ */ m(t, {
												link: e.link,
												linkComponent: S,
												className: "text-sm",
												children: e.label
											})
										}, e.key) : null)]
									}), j && j.links.length > 0 ? /* @__PURE__ */ h("div", {
										className: "flex flex-col items-center gap-2 px-4 py-9",
										children: [j.headline ? /* @__PURE__ */ m("p", {
											className: "mb-2 text-sm text-neutral-500",
											children: j.headline
										}) : null, /* @__PURE__ */ m("ul", {
											className: "flex w-full flex-wrap justify-center gap-2 py-8",
											children: j.links.map((t) => /* @__PURE__ */ m("li", {
												inert: B,
												children: /* @__PURE__ */ m(e, {
													link: t.link,
													linkComponent: S,
													className: "flex h-9 w-9 items-center justify-center",
													"aria-label": t.label,
													children: t.icon
												})
											}, t.key))
										})]
									}) : null]
								})
							]
						})
					})]
				})
			] })
		})] })
	});
}
//#endregion
export { _ as MobileNav };
